import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMenu = () => {
  return (
    <g>
      <path d="m.8555 3.9287h14.289a.75.75 0 0 0 0-1.5h-14.289a.75.75 0 0 0 0 1.5z" />
      <path d="m15.1445 7.25h-14.289a.75.75 0 0 0 0 1.5h14.289a.75.75 0 0 0 0-1.5z" />
      <path d="m15.1445 12.0713h-14.289a.75.75 0 1 0 0 1.5h14.289a.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconMenu);
